// 앱 자체 업데이트(2026-10-16) - "네이티브 셸 전용" 기능이라 실제 확인/다이얼로그/다운로드/설치는
// 전부 Android 네이티브(AppUpdateChecker/AppUpdateDialog, android/app/src/main/java/store/ksolution/kmes/)
// 에서 돈다. 이 파일은 프로필 화면의 "업데이트 확인" 버튼이 그 네이티브 체크를 강제로(throttle 무시)
// 한 번 돌리게 "지금 확인해줘" 신호만 보내는 아주 얇은 다리다 - 결과(새 버전 다이얼로그)는 네이티브
// UI로 바로 뜬다(이 모듈이 응답을 돌려받지 않음).
import { registerPlugin } from '@capacitor/core';
import { App } from '@capacitor/app';
import { isNative } from './biometricLock';

const AppUpdatePlugin = registerPlugin('AppUpdate');

/** 네이티브 플러그인이 없는 환경(웹)에서도 안전하게 - 호출만 하고 결과는 기다리지 않는다. */
export async function requestAppUpdateCheck() {
  if (!isNative()) return;
  try {
    await AppUpdatePlugin.checkNow();
  } catch (e) {
    // 네이티브 쪽에서 조용히 실패해도(네트워크 등) 여기선 무시 - 사용자 플로우를 막지 않는다.
  }
}

/** 프로필 "앱 정보"에 보여줄 설치된 버전 정보. 웹에서는 null. */
export async function getInstalledAppInfo() {
  if (!isNative()) return null;
  try {
    const info = await App.getInfo();
    return { version: info.version, build: info.build }; // version=versionName, build=versionCode
  } catch (e) {
    return null;
  }
}
